/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react'
import {KTCard, KTCardBody} from '../../../../_websoft/helpers'
import {ToastContainer} from 'react-toastify'
import TitleComponent from '../../../components/TitleComponent/TitleComponent'
import {getFmkNalogaStavkaData, spremiFmkNalog} from '../../../api/fmkNalozi'
import {FmkNalogiStavkeModel} from '../../../models/FmkNaloziModel'
import notifyToast from '../../../components/Toast/Toast'
import {flexRender, getCoreRowModel, useReactTable} from '@tanstack/react-table'
import IndeterminateCheckbox from '../../../components/IndeterminateCheckbox/IndeterminateCheckbox'
import KcerkeSifreDropdown from '../../fmk-nalozi/components/KcerkeSifreDropdown'
import LoadingComponent from '../../../components/LoadingComponent/LoadingComponent'
import QrCodeScanner from '../../../components/QrCodeScanner/QrCodeScanner'

const SpremiNalog = () => {
    const [nalog, setNalog] = useState<string>()
    const [loading, setLoading] = useState(false)
    const [dataNaloga, setDataNaloga] = useState<FmkNalogiStavkeModel['nalog'][]>([])
    const [dataStavka, setDataStavka] = useState<FmkNalogiStavkeModel['stavka']>([])
    const [rowSelection, setRowSelection] = useState({})

    // Call api on entering order no.
    const onBtnClick = () => {
        setLoading(true)
        getFmkNalogaStavkaData({nalog})
            .then((response) => {
                if (response.nalog) {
                    const naloga: any = []
                    naloga.push(response.nalog)
                    setDataNaloga(naloga)
                    setDataStavka(response.stavka)
                }
            })
            .catch((error) => notifyToast(false, error.response.data.message))
            .finally(() => setLoading(false))
    }

    // Set cell color according to condtions.
    const getCellColor = (cell, row) => {
        if (cell.column.id === 'Status') return row.original.statusi.Boja
        return '#FFFFFF'
    }

    // Rows where dropdown is displayed are valid rows for update.
    const [validRows, setvalidRows] = useState<any>([])

    // on Potvrdi
    const onClickPotvrdi = () => {
        setLoading(true)
        const payload = table2.getSelectedRowModel().rows.map((row) => {
            const item = row.original
            return {
                Id: item.Id,
                WebsoftSifra: item.ArtikalWebsoft ?? '',
            }
        })

        spremiFmkNalog(payload)
            .then((response) => {
                notifyToast(true, response.message)
                onBtnClick()
            })
            .catch((error) => notifyToast(false, error.response.data.message))
            .finally(() => {
                setLoading(false)
                setRowSelection({})
            })
    }

    const columns1 = [
        {id: 'Kupac', header: 'Kupac', accessorKey: 'Kupac'},
        {id: 'Kreirao', header: 'Nalog Kreirao', accessorKey: 'Korisnik'},
        {id: 'Nalog br', header: 'Nalog br', accessorKey: 'BrojNaloga'},
    ]

    const table1 = useReactTable({
        data: dataNaloga,
        columns: columns1,
        getCoreRowModel: getCoreRowModel(),
    })

    const columns2 = [
        {
            id: 'id',
            header: ({table}) => (
                <div className='d-flex justify-content-center'>
                    <IndeterminateCheckbox
                        {...{
                            checked: table.getIsAllRowsSelected(),
                            indeterminate: table.getIsSomeRowsSelected(),
                            onChange: table.getToggleAllRowsSelectedHandler(),
                        }}
                    />
                </div>
            ),
            cell: ({row}) => (
                <div className='d-flex justify-content-center'>
                    <IndeterminateCheckbox
                        {...{
                            checked: row.getIsSelected(),
                            indeterminate: row.getIsSomeSelected(),
                            onChange: row.getToggleSelectedHandler(),
                        }}
                    />
                </div>
            ),
        },
        {id: 'Šifra', header: 'Šifra', accessorKey: 'IdArtikla'},
        {id: 'ArtikalWebsoft', header: 'Artikal Websoft', cell: TableCell},
        {id: 'Naziv', header: 'Naziv', accessorKey: 'Naziv'},
        {id: 'Mjera', header: 'JM', accessorKey: 'IdJedMjere'},
        {id: 'Kolicina', header: 'Količina', accessorKey: 'Kolicina'},
        {id: 'Status', header: 'Status', accessorKey: 'statusi.Naziv'},
    ]

    const table2 = useReactTable({
        data: dataStavka,
        columns: columns2,
        // @ts-ignore
        initialState: {hiddenColumns: ['ArtikalWebsoft']},
        getCoreRowModel: getCoreRowModel(),
        state: {rowSelection},
        meta: {
            updateData: (rowIndex: number, columnId: string, value: string) => {
                setDataStavka((old) =>
                    old.map((row, index) => {
                        if (index === rowIndex) {
                            return {
                                ...old[rowIndex],
                                [columnId]: value,
                            }
                        }
                        return row
                    })
                )
            },
        },
        onRowSelectionChange: setRowSelection,
        enableRowSelection: true,
    })

    return (
        <KTCard>
            <ToastContainer />

            <KTCardBody className='py-4'>
                <div className='container-fluid px-0 px-md-3'>
                    {/* Title */}
                    <div className='d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2 mb-4'>
                        <TitleComponent name='Spremi Nalog' />
                        <div className='text-muted small'>
                            Skeniraj ili unesi broj naloga, učitaj stavke i potvrdi Websoft šifre.
                        </div>
                    </div>

                    {/* Search / Scan bar */}
                    <div className='card shadow-sm border-0 mb-4'>
                        <div className='card-body'>
                            <div className='row g-3 align-items-end'>
                                <div className='col-12 col-md-auto'>
                                    <div className='text-muted small mb-1'>Skeniraj</div>
                                    <div
                                        className='d-inline-flex align-items-center justify-content-center border rounded bg-light'
                                        style={{width: 56, height: 48}}
                                        title='Skeniraj QR'
                                    >
                                        <QrCodeScanner
                                            onScan={(text) => {
                                                setNalog(text)
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className='col-12 col-md-6 col-lg-4'>
                                    <label className='form-label fw-bold mb-1'>Broj naloga</label>
                                    <input
                                        type='text'
                                        className='form-control form-control-lg form-control-solid'
                                        value={nalog}
                                        placeholder='Unesi broj naloga...'
                                        onChange={(e) => setNalog(e.target.value)}
                                        onKeyDown={(e) => e.key === 'Enter' && onBtnClick()}
                                    />
                                </div>

                                <div className='col-12 col-md-auto'>
                                    <button className='btn btn-primary btn-lg px-4 w-100' onClick={onBtnClick} disabled={loading}>
                                        {!loading ? (
                                            <>
                                                <i className='bi bi-search me-2' />
                                                Učitaj
                                            </>
                                        ) : (
                                            <span className='d-inline-flex align-items-center gap-2'>
                        Učitavam...
                        <span className='spinner-border spinner-border-sm align-middle' />
                      </span>
                                        )}
                                    </button>
                                </div>

                                <div className='col-12 col-lg'>
                                    <div className='d-flex flex-wrap gap-2 justify-content-start justify-content-lg-end'>
                    <span className='badge bg-light text-dark border'>
                      Nalog: <span className='fw-semibold'>{nalog || '-'}</span>
                    </span>
                                        <span className='badge bg-light text-dark border'>
                      Stavke: <span className='fw-semibold'>{dataStavka?.length ?? 0}</span>
                    </span>
                                        <span className='badge bg-light text-dark border'>
                      Odabrano: <span className='fw-semibold'>{table2.getSelectedRowModel().rows.length}</span>
                    </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {loading ? (
                        <div className='card shadow-sm border-0'>
                            <div className='card-body p-5'>
                                <LoadingComponent />
                            </div>
                        </div>
                    ) : (
                        <>
                            {/* Nalog info table */}
                            <div className='card shadow-sm border-0 mb-4'>
                                <div className='card-header bg-success text-white d-flex align-items-center justify-content-between'>
                                    <div className='fw-bolder'>Podaci o nalogu</div>
                                    <div className='small opacity-75'>1 red</div>
                                </div>

                                <div className='card-body p-0'>
                                    <div className='table-responsive'>
                                        <table className='table table-hover align-middle mb-0'>
                                            <thead className='table-light'>
                                            {table1.getHeaderGroups().map((headerGroup) => (
                                                <tr key={headerGroup.id}>
                                                    {headerGroup.headers.map((header) => (
                                                        <th key={header.id} className='text-nowrap'>
                                                            <div className='d-flex align-items-center gap-2'>
                                                                {flexRender(header.column.columnDef.header, header.getContext())}
                                                            </div>
                                                        </th>
                                                    ))}
                                                </tr>
                                            ))}
                                            </thead>

                                            <tbody>
                                            {table1.getRowModel().rows && table1.getRowModel().rows.length > 0 ? (
                                                table1.getRowModel().rows.map((row) => (
                                                    <tr key={row.id}>
                                                        {row.getVisibleCells().map((cell) => (
                                                            <td key={cell.id} className='py-3'>
                                                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={7}>
                                                        <div className='text-center text-muted py-4'>Nema podataka.</div>
                                                    </td>
                                                </tr>
                                            )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            {/* Stavke table */}
                            <div className='card shadow-sm border-0'>
                                <div className='card-header bg-dark text-white d-flex flex-column flex-md-row gap-2 align-items-start align-items-md-center justify-content-between'>
                                    <div className='fw-bolder'>Stavke naloga</div>
                                    <div className='small opacity-75'>
                                        Odaberi redove koje želiš spremiti (checkbox).
                                    </div>
                                </div>

                                <div className='card-body p-0'>
                                    <div className='table-responsive'>
                                        <table className='table table-striped table-hover align-middle mb-0'>
                                            <thead className='table-light'>
                                            {table2.getHeaderGroups().map((headerGroup) => (
                                                <tr key={headerGroup.id}>
                                                    {headerGroup.headers.map((header) => (
                                                        <th key={header.id} className='text-nowrap'>
                                                            <div className='d-flex align-items-center gap-2'>
                                                                {flexRender(header.column.columnDef.header, header.getContext())}
                                                            </div>
                                                        </th>
                                                    ))}
                                                </tr>
                                            ))}
                                            </thead>

                                            <tbody>
                                            {table2.getRowModel().rows && table2.getRowModel().rows.length > 0 ? (
                                                table2.getRowModel().rows.map((row) => (
                                                    <tr key={row.id}>
                                                        {row.getVisibleCells().map((cell) => (
                                                            <td
                                                                key={cell.id}
                                                                className='py-3'
                                                                style={{backgroundColor: getCellColor(cell, row)}}
                                                            >
                                                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={7}>
                                                        <div className='text-center text-muted py-4'>Nema stavki.</div>
                                                    </td>
                                                </tr>
                                            )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Action bar */}
                                    <div className='border-top p-3 p-md-4 d-flex flex-column flex-md-row gap-3 align-items-start align-items-md-center justify-content-between bg-white'>
                                        <div className='text-muted'>
                                            Odabrano: <span className='fw-semibold'>{table2.getSelectedRowModel().rows.length}</span>
                                        </div>

                                        <div className='ms-md-auto w-100 w-md-auto'>
                                            <button
                                                type='button'
                                                className='btn btn-primary btn-lg px-4 w-100'
                                                disabled={loading}
                                                onClick={onClickPotvrdi}
                                            >
                                                {!loading ? (
                                                    <>
                                                        <i className='bi bi-check2-circle me-2' />
                                                        Potvrdi
                                                    </>
                                                ) : (
                                                    <span className='d-inline-flex align-items-center gap-2'>
                            Please wait...
                            <span className='spinner-border spinner-border-sm align-middle' />
                          </span>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </KTCardBody>
        </KTCard>
    )
}

export default SpremiNalog

const TableCell = ({getValue, row, column, table}) => {
    const initialValue = getValue()
    const [value, setValue] = useState(initialValue)

    useEffect(() => {
        setValue(initialValue)
    }, [initialValue])

    useEffect(() => {
        table.options.meta?.updateData(row.index, column.id, value)
    }, [value])

    return (
        <KcerkeSifreDropdown
            sifra={row.original.IdArtikla}
            value={value}
            onChange={(name, value) => setValue(value)}
        />
    )
}
